import { useCallback, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Tab, Tabs } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useRecalculateElo, useSetUserRole } from "../hooks/mutations/useUserMutations";
import AuditLogTab from "../components/admin/AuditLogTab";
import ZakulisiTab from "../components/admin/ZakulisiTab";
import { useAuth } from "../util/SecurityUtils";

function Administration() {
    const { t } = useTranslation();
    const [userId, setUserId] = useState(0);
    const recalculateEloMutation = useRecalculateElo();
    const setUserRoleMutation = useSetUserRole();
    const { user, validated } = useAuth();

    // Hooks must run unconditionally — keep useCallback above the early returns.
    const recalculateElo = useCallback(async () => {
        await recalculateEloMutation.mutateAsync();
    }, [recalculateEloMutation]);

    const setRole = useCallback(async (role: "USER" | "ADMIN") => {
        await setUserRoleMutation.mutateAsync({ userId, role });
    }, [userId, setUserRoleMutation]);

    if (!validated) {
        return (
            <div className="base-container">
                <div className="table-header header">
                    <span className="table-title">{t("administration")}</span>
                </div>
                <div className="p-4 text-center" style={{ color: "var(--text-muted)" }}>
                    {t("loading")}...
                </div>
            </div>
        );
    }

    if (user?.role !== "SUPERADMIN") {
        return (
            <div className="base-container">
                <div className="table-header header">
                    <span className="table-title">{t("administration")}</span>
                </div>
                <div className="p-4 text-center" style={{ color: "var(--text-muted)" }}>
                    {t("accessDenied")}
                </div>
            </div>
        );
    }

    return (
        <div className="base-container">
            <div className="table-header header">
                <span className="table-title">{t("administration")}</span>
            </div>
            <Tabs defaultActiveKey="actions" id="admin-tabs" variant="tabs" className="theme-tabs mt-3">
                <Tab eventKey="actions" title={t("administrationActions")}>
                    <div className="mt-3">
                        <div className="header-with-buttons mb-3 me-3">
                            <Button variant="info" onClick={() => recalculateElo()} className="table-button">
                                {t("recalculateElo")}
                            </Button>
                        </div>
                        <div className="header-with-buttons mb-3 me-3">
                            <Form.Control type="number" onChange={e => setUserId(Number(e.target.value))} value={userId} />
                            <Button variant="secondary" onClick={() => setRole("USER")} className="table-button">
                                UDELEJ ZE ME USERA
                            </Button>
                            <Button variant="success" onClick={() => setRole("ADMIN")} className="table-button">
                                UDELEJ ZE ME ADMINA
                            </Button>
                        </div>
                    </div>
                </Tab>
                <Tab eventKey="zakulisi" title={t("zakulisi")}>
                    <ZakulisiTab />
                </Tab>
                <Tab eventKey="audit-log" title={t("auditLog")}>
                    <AuditLogTab />
                </Tab>
            </Tabs>
        </div>
    );
}

export default Administration;
